import type { Location, NavigateFunction } from 'react-router-dom';
import type { ReferenceCardLocationState } from '../types/referenceCardNavigation';

/** Открыть карточку справочника поверх текущей страницы (история: список → карточка; закрытие: navigate(-1)). */
export function navigateToReferenceCard(
  navigate: NavigateFunction,
  to: string,
  currentLocation: Location
): void {
  const state: ReferenceCardLocationState = { backgroundLocation: currentLocation };
  navigate(to, { state });
}
